import type { MachineEntity } from './entities';
import type { PacketId } from './types';

function emptyPorts(machine: MachineEntity): PacketId[] {
  return [...machine.inputs, ...machine.outputs].flatMap((port) => port.queue.splice(0));
}

/**
 * A packet parked outside every port — `switchMap`'s in-flight sale is the only one today — would
 * otherwise survive an unsubscribe that is meant to end everything in flight, left in `state.packets`
 * with nothing on the board pointing at it.
 */
function releaseParkedPacket(machine: MachineEntity): PacketId[] {
  if (machine.kind !== 'switchMap' || !machine.internal.pending) return [];
  const { packetId } = machine.internal.pending;
  machine.internal.pending = null;
  return [packetId];
}

/** Reports what came out, for the caller to despawn. */
export function releaseMachinePackets(machine: MachineEntity): PacketId[] {
  return [...emptyPorts(machine), ...releaseParkedPacket(machine)];
}
